import { observer } from "mobx-react-lite/dist"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import useStore from "reusable/mobx-store-utils"
import CreateClientContactModalStore from "./CreateClientContactModalStore"
import { useCreateClientContactAutocompleteStore } from "./CreateClientContactAutocompleteStore"
import GapDialog from "reusable/gap-dialog/GapDialog"
import TextFieldEmail from "reusable/mui/text-field-email/TextFieldEmail"
import onEnterProp from "reusable/utils/on-enter-prop"

export interface CreateClientContactModalParams {
   advisorClientId: string
}

export default observer(function CreateClientContactModal(props: CreateClientContactModalParams) {
   const createClientContactAutocompleteStore = useCreateClientContactAutocompleteStore()
   const createClientContactModal = useStore((sp) => new CreateClientContactModalStore(sp), { createClientContactAutocompleteStore, advisorClientId: props.advisorClientId })

   return <GapDialog
      size="small"
      title="Create contact"
      primary={{
         name: 'Create',
         callback: createClientContactModal.createClientContact,
         loading: createClientContactModal.loader.isLoading
      }}
      cancel={{
         name: 'Cancel',
         callback: createClientContactAutocompleteStore.closeCreateClientContactModal
      }}
      open={createClientContactAutocompleteStore.showCreateClientContactModal}>
      <Box>
         {createClientContactModal.formHandler.firstName.bindInput(ip =>
            <TextField fullWidth label="First name" autoFocus {...onEnterProp(createClientContactModal.createClientContact)} {...ip} />
         )}
      </Box>
      <Box sx={{ pt: 3 }}>
         {createClientContactModal.formHandler.lastName.bindInput(ip =>
            <TextField fullWidth label="Last name" {...onEnterProp(createClientContactModal.createClientContact)} {...ip} />
         )}
      </Box>
      <Box sx={{ pt: 3, pb: 1 }}>
         {createClientContactModal.formHandler.email.bindInput(ip =>
            <TextFieldEmail fullWidth label="Email" {...onEnterProp(createClientContactModal.createClientContact)} ip={ip} />
         )}
      </Box>
   </GapDialog>
})
